module.exports = __webpack_public_path__ + "static/media/PSN5.ebc1b7ea.png";